import React from 'react';
import { matchPath } from 'react-router';
import _ from 'lodash';
import DashboardPage from '../containers/DashboardPage/DashboardPage';
import SimsPage from '../containers/SimsPage';
import SimsInfoPage from '../containers/SimsInfoPage';
import SwitchSimCardPage from '../containers/SwitchSimCardPage/SwitchSimCardPage';
import B2bOrderPage from '../containers/B2bOrderPage';
import ActivateSubscriptionPage from '../containers/ActivateSubscriptionPage';
import MoreSimsPage from '../containers/MoreSimsPage/MoreSimsPage';
import SubscriptionsOrderPage from '../containers/SubscriptionsOrderPage';
import InvoicesPage from '../containers/InvoicesPage/InvoicesPage';
import CustomerInfoPage from '../containers/CustomerInfoPage/CustomerInfoPage';
import UpdatePasswordPage from '../containers/UpdatePasswordPage/UpdatePasswordPage';
import EditBillingEmailPage from '../containers/EditBillingEmailPage/EditBillingEmailPage';
import CreditCardInfoPage from '../containers/CreditCardInfoPage';
import { CustomerServicePage } from '../containers/CustomerServicePage/CustomerServicePage';
import NotFoundPage from '../containers/NotFoundPage';
import { Redirect } from 'react-router-dom';
import { ACCOUNT_TYPE_BUSINESS, ACCOUNT_TYPE_CONSUMER, allOfferingTypes, getAccountType, OfferingType } from './offeringType';
import { getEnumById } from './helpers';

const RedirectToLogin = () => <Redirect to="/login" />;

interface RouteConfig {
	path: string;
	component: any;
	private?: boolean;
	menuIcon?: (offeringType: OfferingType) => string | undefined;
	authorized: (offeringType: OfferingType) => boolean;
}

const acceptAll = (customerData: any) => true;

const filterByAccountType = (acceptableAccountTypes: string[]) => {
	return (customerData: any) => _.includes(acceptableAccountTypes, getAccountType(getEnumById(customerData.emoSubscriptionType, allOfferingTypes)));
};

const menuItem = (filter: (offeringType: OfferingType) => boolean, icon: string) => {
	return (offeringType: OfferingType) => (filter(offeringType) ? icon : undefined);
};

export const getRoutes = (): RouteConfig[] => {
	return [
		{
			path: '/account/dashboard',
			component: DashboardPage,
			private: true,
			menuIcon: menuItem(acceptAll, 'small--smile-bubble'),
			authorized: acceptAll
		},
		{
			path: '/account/sims/:id',
			component: SimsInfoPage,
			private: true,
			authorized: acceptAll
		},
		{
			path: '/account/sims',
			component: SimsPage,
			private: true,
			menuIcon: menuItem(acceptAll, 'small--sims'),
			authorized: acceptAll
		},
		{
			path: '/account/switchSimCard',
			component: SwitchSimCardPage,
			private: true,
			authorized: filterByAccountType([ACCOUNT_TYPE_BUSINESS])
		},
		{
			path: '/account/order',
			component: B2bOrderPage,
			private: true,
			menuIcon: menuItem(filterByAccountType([ACCOUNT_TYPE_BUSINESS]), 'small--datacake'),
			authorized: filterByAccountType([ACCOUNT_TYPE_BUSINESS])
		},
		{
			path: '/account/activateSubscription',
			component: ActivateSubscriptionPage,
			private: true,
			menuIcon: menuItem(filterByAccountType([ACCOUNT_TYPE_BUSINESS]), 'small--phone'),
			authorized: acceptAll
		},
		{
			path: '/account/orderMore',
			component: MoreSimsPage,
			private: true,
			menuIcon: menuItem(filterByAccountType([ACCOUNT_TYPE_BUSINESS]), 'small--sim-plus'),
			authorized: filterByAccountType([ACCOUNT_TYPE_BUSINESS])
		},
		{
			path: '/account/subscriptionsOrder',
			component: SubscriptionsOrderPage,
			private: true,
			menuIcon: menuItem(filterByAccountType([ACCOUNT_TYPE_CONSUMER]), 'small--sim-plus'),
			authorized: filterByAccountType([ACCOUNT_TYPE_CONSUMER])
		},
		{
			path: '/account/invoices',
			component: InvoicesPage,
			private: true,
			menuIcon: menuItem(acceptAll, 'small--invoice'),
			authorized: acceptAll
		},
		{
			path: '/account/customerInfo',
			component: CustomerInfoPage,
			private: true,
			menuIcon: menuItem(acceptAll, 'small--smile'),
			authorized: acceptAll
		},
		{
			path: '/account/changePassword',
			component: UpdatePasswordPage,
			private: true,
			authorized: acceptAll
		},
		{
			path: '/account/editBillingEmail',
			component: EditBillingEmailPage,
			private: true,
			authorized: filterByAccountType([ACCOUNT_TYPE_BUSINESS])
		},
		{
			path: '/account/creditCardInformation',
			component: CreditCardInfoPage,
			private: true,
			authorized: filterByAccountType([ACCOUNT_TYPE_CONSUMER])
		},
		{
			path: '/account/customer-service',
			component: CustomerServicePage,
			private: true,
			menuIcon: menuItem(acceptAll, 'small--customer-service'),
			authorized: acceptAll
		},
		{
			path: '/login',
			component: (props: any) => <RedirectTo {...props} to={`${window.location.origin}/tili/kirjaudu`} />,
			authorized: acceptAll
		},
		{
			path: '/forgot-password',
			component: (props: any) => <RedirectTo {...props} to={`${window.location.origin}/tili/unohtunut-salasana`} />,
			authorized: acceptAll
		},
		{
			path: '/resetAndChangePassword',
			component: (props: any) => <RedirectTo {...props} to={`${window.location.origin}/tili/salasanan-vaihto`} />,
			authorized: acceptAll
		},
		{
			path: '/',
			component: RedirectToLogin,
			authorized: acceptAll
		},
		{
			path: '*',
			component: NotFoundPage,
			authorized: acceptAll
		}
	];
};

export const getRouteByPathName = (path: string) => {
	return getRoutes().find((route) => {
		const match = matchPath(path, {
			path: route.path,
			exact: true
		});
		return match !== null;
	});
};

const RedirectTo = ({ location, to }: {location: Location, to: string}) => {
	window.location.href = to + location.search;
	return <></>
};